import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\GetDocumentActivitiesByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentActivitiesByIdController.php
* @route '/api/document/{document}/activities'
*/
const GetDocumentActivitiesByIdController = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDocumentActivitiesByIdController.url(args, options),
    method: 'get',
})

GetDocumentActivitiesByIdController.definition = {
    methods: ["get","head"],
    url: '/api/document/{document}/activities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Document\GetDocumentActivitiesByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentActivitiesByIdController.php
* @route '/api/document/{document}/activities'
*/
GetDocumentActivitiesByIdController.url = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { document: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { document: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            document: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        document: typeof args.document === 'object'
        ? args.document.id
        : args.document,
    }

    return GetDocumentActivitiesByIdController.definition.url
            .replace('{document}', parsedArgs.document.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\GetDocumentActivitiesByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentActivitiesByIdController.php
* @route '/api/document/{document}/activities'
*/
GetDocumentActivitiesByIdController.get = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetDocumentActivitiesByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Document\GetDocumentActivitiesByIdController::__invoke
* @see app/Http/Controllers/Document/GetDocumentActivitiesByIdController.php
* @route '/api/document/{document}/activities'
*/
GetDocumentActivitiesByIdController.head = (args: { document: string | number | { id: string | number } } | [document: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetDocumentActivitiesByIdController.url(args, options),
    method: 'head',
})

export default GetDocumentActivitiesByIdController